import React from "react";
import "../../style/appointmentDetails.css";

export default function PolicyDetails(props) {
    const { maskedWellnessId, policyBuyerName, maskedCustomerEmail, maskedCustomerContactNumber } = props.caseData;
    return (
        <div className='policy-details-background'>
            <div className='policy-details'>
                <span className='policy-details-key'>Policy Number:</span>
                <span className='policy-details-value'>{maskedWellnessId}</span>
            </div>
            <div className='policy-details'>
                <span className='policy-details-key'>Name: </span>
                <span className='policy-details-value'>{policyBuyerName}</span>
            </div>
            <div className='policy-details'>
                <span className='policy-details-key'>Contact Number: </span>
                <span className='policy-details-value'>{maskedCustomerContactNumber}</span>
            </div>
            <div className='policy-details'>
                <span className='policy-details-key'>Email ID: </span>
                <span className='policy-details-value'>{maskedCustomerEmail}</span>
            </div>
        </div>
    );
}